/** Menú del módulo Weight Loss — segmentos relativos al basePath del contexto. */
export const weightLossMenuGroups = [
  {
    label: 'Operations',
    items: [
      { segment: 'reports', label: 'Reports', icon: 'fas fa-chart-bar' },
      { segment: 'patients', label: 'Program patients', icon: 'fas fa-user-injured' },
      { segment: 'appointments', label: 'Appointments', icon: 'fas fa-calendar-alt' },
      { segment: 'visits', label: 'Visits', icon: 'fas fa-calendar-check' },
    ],
  },
  {
    label: 'Configuration',
    items: [
      { segment: 'config/treatments', label: 'Treatments', icon: 'fas fa-pills' },
      { segment: 'config/prices', label: 'Prices', icon: 'fas fa-dollar-sign' },
      { segment: 'config/addons', label: 'Add-ons', icon: 'fas fa-plus-circle' },
    ],
  },
  {
    label: 'Inventory',
    items: [
      { segment: 'inventory/categories', label: 'Categories', icon: 'fas fa-tags' },
      { segment: 'inventory/distributors', label: 'Distributors', icon: 'fas fa-truck' },
      { segment: 'inventory/items', label: 'Items', icon: 'fas fa-boxes' },
      { segment: 'inventory/movements', label: 'Movements', icon: 'fas fa-exchange-alt' },
      { segment: 'inventory/stock', label: 'Current stock', icon: 'fas fa-warehouse' },
    ],
  },
]

export const weightLossBasePaths = {
  normal: '/weightloss',
  insurance: '/insurance-weightloss',
}

export function weightLossPath(context, segment = '') {
  const base = weightLossBasePaths[context] || weightLossBasePaths.normal
  return segment ? `${base}/${segment}` : base
}
